import { generateFormData } from '@shared/utils/publicMethods';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// 引入公共函数
import * as publicMethods from '../../../shared/utils/publicMethods';
// 引入系统维护请求地址文件
import { xtwhUrls } from '../../../shared/urls/xtwhUrls';
import { publicUrls } from '@shared/urls/publicUrls';
import { loginUrls } from '@shared/urls/loginUrls';

@Injectable({
  providedIn: 'root',
})
export class XtwhRequestService {
  constructor(private http: HttpClient) { }

  // 查询院系下拉框
  queryYxInfoCombobox() {
    const url = xtwhUrls.queryYxInfo;
    return this.http.post(url, {});
  }

  // 系统维护 - 用户角色
  // 查询用户信息
  queryUserInfo(name?: any, page?: any, rows?: any) {
    const url = xtwhUrls.userInfo.queryUserInfo;
    const params = publicMethods.generateFormData({ name, page, rows });
    return this.http.post(url, params);
  }

  // 新增和修改角色信息
  addOrEditRoleInfo(name: any, description?: any, openid?: string) {
    if (!openid) {
      openid = '';
    }
    const url = xtwhUrls.roleInfo.addOrEdit;
    const params = publicMethods.generateFormData({ name, description, openid });
    return this.http.post(url, params);
  }

  // 查询角色列表
  queryRoleInfo(page?: any, rows?: any, name = '') {
    const url = xtwhUrls.roleInfo.pagingQueryRoleInfo;
    const params = publicMethods.generateFormData({ page, rows, name });
    return this.http.post(url, params);
  }

  // 根据角色id查询教师列表
  queryTeacherList(roleId?: any, name?: any, page?: any, rows?: any) {
    const url = xtwhUrls.userRole.queryTeacherInfo;
    const params = publicMethods.generateFormData({ qxmkOpenid: roleId, jsName: name, page, rows });
    return this.http.post(url, params);
  }

  // 查询全部教师信息
  queryAllTeacherInfo(name?: any, yxid?: any, page?: any, rows?: any) {
    const url = publicUrls.queryAllTeacherInfo;
    const params = publicMethods.generateFormData({ name, yxxxId: yxid, page, rows });
    return this.http.post(url, params);
  }

  // 添加教师的角色信息
  addTeacherRoleInfo(jsOpenid: any, qxmkOpenids: any) {
    const url = xtwhUrls.userRole.addTeacherRoleInfo;
    const params = publicMethods.generateFormData({ jsOpenid, qxmkOpenids });
    return this.http.post(url, params);
  }

  // 删除教师的角色信息
  delTeacherRoleInfo(jsOpenid: string, qxmkOpenid: string) {
    const url = xtwhUrls.userRole.delTeacherRoleInfo;
    const params = publicMethods.generateFormData({ jsOpenid, qxmkOpenid });
    return this.http.post(url, params);
  }

  // 系统维护 - 权限分配
  // 查询所有权限信息
  queryAllQxInfo(page: any, rows: any, name?: any) {
    const url = xtwhUrls.qxwh.queryQxInfo;
    const params = publicMethods.generateFormData({ page, rows, name });
    return this.http.post(url, params);
  }

  // 新增或修改权限动作信息
  addOrEditQxUrlInfo(params: any) {
    const url = xtwhUrls.qxwh.addOrEditQx;
    const _params = publicMethods.generateFormData(params);
    return this.http.post(url, _params);
  }

  // 启用禁用权限
  enableQX(id: any, enable: any) {
    const url = xtwhUrls.qxwh.enable;
    const params = publicMethods.generateFormData({ openid: id, enable });
    return this.http.post(url, params);
  }

  // 根据id删除权限动作信息
  delQxUrlInfo(openid: any) {
    const url = xtwhUrls.qxwh.delQxUrlInfo;
    const params = publicMethods.generateFormData({ openid });
    return this.http.post(url, params);
  }

  // 修改新增时获取所有动作响应类型
  getAllDzXyType() {
    const url = xtwhUrls.qxwh.getAllDzXyType;
    const params = '';
    return this.http.post(url, params);
  }

  // 请求所有可以选择的权限父对象
  getAllQxfdx() {
    const url = xtwhUrls.qxwh.getAllQxfdx;
    const params = '';
    return this.http.post(url, params);
  }

  // 获取父级所有可以选择的权限父对象
  getFPermissions(qxlx: number) {
    const url = xtwhUrls.qxwh.getFPermissions;
    const params = publicMethods.generateFormData({ qxlx });
    return this.http.post(url, params);
  }

  // 获取所有权限树
  getAllPermissionTree() {
    const url = xtwhUrls.qxwh.getAllPermissionTree;
    const params = '';
    return this.http.post(url, params);
  }

  // 根据角色id查询权限树
  getPermissionsTree(id: any) {
    const url = xtwhUrls.qxwh.getRoleQxTree;
    const params = publicMethods.generateFormData({ yhjsOpenid: id });
    return this.http.post(url, params);
  }

  // 保存角色权限树修改
  saveRoleQxTree(mOpenid: any, qxOpenids: any) {
    const url = xtwhUrls.qxwh.saveRoleQxTree;
    const params = publicMethods.generateFormData({ mOpenid, qxOpenids });
    return this.http.post(url, params);
  }

  // 获取所有部门
  getAlldepartment(name: any, page: any, rows: any) {
    const url = xtwhUrls.qxwh.getAlldepartment;
    const params = publicMethods.generateFormData({ name, page, rows });
    return this.http.post(url, params);
  }

  // 根据部门id查询部门权限
  getdepartmentQx(id: any) {
    const url = xtwhUrls.qxwh.getDepartmentQxTree;
    const params = publicMethods.generateFormData({ zzjgOpenid: id });
    return this.http.post(url, params);
  }

  // 保存部门权限树修改
  saveBmQxTree(zzjgOpenid: any, qxdzOpenids: any) {
    const url = xtwhUrls.qxwh.saveBmQxTree;
    const params = publicMethods.generateFormData({ zzjgOpenid, qxdzOpenids });
    return this.http.post(url, params);
  }

  // 获取部门列表（教师权限页面左侧）
  getAlldepartmentList() {
    const url = xtwhUrls.qxwh.getAllDePartmentList;
    const params = '';
    return this.http.post(url, params);
  }

  // 获取教师列表
  getAllTeacherList(yxxxId?: any, name?: any, page?: any, rows?: any) {
    const url = xtwhUrls.qxwh.getAllTeacherList;
    const params = publicMethods.generateFormData({ yxxxId, name, page, rows });
    return this.http.post(url, params);
  }

  // 获取组织机构教师列表
  getZzjgTeacherList(zzjgOpenid?: string, jsName?: string, page?: number, rows?: number) {
    const _url = xtwhUrls.qxwh.getZzjgTeacherList;
    const params = publicMethods.generateFormData({ zzjgOpenid, jsName, page, rows });
    return this.http.post(_url, params);
  }

  // 查询教师角色列表（教师权限最右侧）
  getTeacherRoleList(jsOpenid: string, qxmkName: string, page: number, rows: number) {
    const url = xtwhUrls.qxwh.getTeacherRoleList;
    const params = publicMethods.generateFormData({ jsOpenid, qxmkName, page, rows });
    return this.http.post(url, params);
  }

  // 保存教师权限
  saveTeacherQx(jsOpenid: string, qxOpenids?: string) {
    const url = xtwhUrls.qxwh.saveTeacherQx;
    const params = publicMethods.generateFormData({ jsOpenid, qxOpenids });
    return this.http.post(url, params);
  }

  // 根据教师查询权限id集合
  getQxIdsByTeacher(jsOpenid: string) {
    const url = xtwhUrls.qxwh.getQxIdsByTeacher;
    const params = publicMethods.generateFormData({ jsOpenid });
    return this.http.post(url, params);
  }

  // 删除教师角色
  deleteTeacherRole(jsOpenid: string, qxmkOpenid: string) {
    const url = xtwhUrls.qxwh.deleteTeacherRole;
    const params = publicMethods.generateFormData({ jsOpenid, qxmkOpenid });
    return this.http.post(url, params);
  }

  // 保存教师角色
  saveTeacherRole(jsOpenid: string, qxmkOpenids: string) {
    const url = xtwhUrls.qxwh.saveTeacherRole;
    const params = publicMethods.generateFormData({ jsOpenid, qxmkOpenids });
    return this.http.post(url, params);
  }

  // 分页查询APP应用
  pagingQueryApp(name: any, page: any, rows: any) {
    const url = xtwhUrls.app.pagingQueryApp;
    const params = publicMethods.generateFormData({ name, page, rows });
    return this.http.post(url, params);
  }

  // 启用/禁用app应用
  enableApp(openid: string, enable: number) {
    const url = xtwhUrls.app.enableApp;
    const params = publicMethods.generateFormData({ openid, enable });
    return this.http.post(url, params);
  }

  // 保存app应用
  addOrEditApp(
    name: string,
    identifier: string,
    url: string,
    imgUrl: string,
    enable: number,
    ord: number,
    description?: string,
    openid?: string,
  ) {
    const lj = xtwhUrls.app.addOrEditApp;
    const params = publicMethods.generateFormData({ name, identifier, url, imgUrl, enable, ord, description, openid });
    return this.http.post(lj, params);
  }

  // 下载APP应用图标
  downLoadIcon(openid: string) {
    const url = xtwhUrls.app.downLoadIcon;
    const token = JSON.parse(window.sessionStorage.getItem('_token')).token;
    // return this.http.get(url, { params: { openid, token } });
    // return $.fileDownload('/feather/menuinfo/down_icon?openid=' + openid + '&token=' + token);
    return 'down';
  }

  // 分页查询角色应用信息
  pagingQueryRoleAppInfo(yhjsid: string, page: number, rows: number) {
    const url = xtwhUrls.app.pagingQueryRoleAppInfo;
    const params = publicMethods.generateFormData({ yhjsid, page, rows });
    return this.http.post(url, params);
  }

  // 删除角色应用信息
  deleteRoleAppInfo(yhjsid: string, menuinfoids: any) {
    const url = xtwhUrls.app.deleteRoleAppInfo;
    const params = publicMethods.generateFormData({ yhjsid, menuinfoids });
    return this.http.post(url, params);
  }

  // 分页查询部门应用信息
  pagingQueryBmAppInfo(deptid: string, page: number, rows: number) {
    const url = xtwhUrls.app.pagingQueryBmAppInfo;
    const params = publicMethods.generateFormData({ deptid, page, rows });
    return this.http.post(url, params);
  }

  // 删除部门应用信息
  deleteBmAppInfo(deptid: string, menuinfoids: any) {
    const url = xtwhUrls.app.deleteBmAppInfo;
    const params = publicMethods.generateFormData({ deptid, menuinfoids });
    return this.http.post(url, params);
  }

  // 分页查询教师应用信息
  pagingQueryTeacherAppInfo(teacherid: string, page: number, rows: number) {
    const url = xtwhUrls.app.pagingQueryTeacherAppInfo;
    const params = publicMethods.generateFormData({ teacherid, page, rows });
    return this.http.post(url, params);
  }

  // 删除教师应用信息
  deleteTeacherAppInfo(teacherid: string, menuinfoids: any) {
    const url = xtwhUrls.app.deleteTeacherAppInfo;
    const params = publicMethods.generateFormData({ teacherid, menuinfoids });
    return this.http.post(url, params);
  }

  // 查询所有部门列表（树形表格）
  queryAllBmList() {
    const url = xtwhUrls.fzrgl.queryAllBmList;
    const params = '';
    return this.http.post(url, params);
  }

  // 根据部门id新增院系负责人
  addYxFzrSave(userid: string, typeid: string, type = 'dept') {
    const url = xtwhUrls.fzrgl.addYxFzrSave;
    const params = publicMethods.generateFormData({ userid, typeid, type });
    return this.http.post(url, params);
  }

  // 根据部门id查询用户
  bmIdQueryUser(typeid?: string, page?: number, rows?: number, type = 'dept') {
    const url = xtwhUrls.fzrgl.typeIdQueryUser;
    const params = publicMethods.generateFormData({ typeid, page, rows, type });
    return this.http.post(url, params);
  }

  // 根据专业id查询用户
  zyIdQueryUser(typeid?: string, page?: number, rows?: number, type = 'major') {
    const url = xtwhUrls.fzrgl.typeIdQueryUser;
    const params = publicMethods.generateFormData({ typeid, page, rows, type });
    return this.http.post(url, params);
  }

  // 根据部门id新增专业负责人
  addZyFzrSave(userid: string, typeid: string, type = 'major') {
    const url = xtwhUrls.fzrgl.addYxFzrSave;
    const params = publicMethods.generateFormData({ userid, typeid, type });
    return this.http.post(url, params);
  }

  // 根据行政班id查询用户
  xzbIdQueryUser(typeid?: string, page?: number, rows?: number, type = 'grade') {
    const url = xtwhUrls.fzrgl.typeIdQueryUser;
    const params = publicMethods.generateFormData({ typeid, page, rows, type });
    return this.http.post(url, params);
  }

  // 根据部门id新增行政班负责人
  addXzbFzrSave(userid: string, typeid: string, type = 'grade') {
    const url = xtwhUrls.fzrgl.addYxFzrSave;
    const params = publicMethods.generateFormData({ userid, typeid, type });
    return this.http.post(url, params);
  }

  // 查询所有专业列表（树形表格）
  queryAllZyList() {
    const url = xtwhUrls.fzrgl.queryAllZyList;
    const params = '';
    return this.http.post(url, params);
  }

  // 分页查询行政班信息
  pagingQueryXzbInfo(
    zyOpenid?: string,
    name?: string,
    yxxxid?: string,
    njOpenid?: string,
    isAll?: number,
    page?: number,
    rows?: number,
  ) {
    const url = xtwhUrls.fzrgl.pagingQueryXzbInfo;
    const params = publicMethods.generateFormData({ zyOpenid, name, yxxxid, njOpenid, isAll, page, rows });
    return this.http.post(url, params);
  }

  // 分页查询流程模板
  pagingQueryLcmb(page: number, rows: number) {
    const url = xtwhUrls.lcgl.pagingQueryLcmb;
    const params = publicMethods.generateFormData({ page, rows });
    return this.http.post(url, params);
  }

  // 查询所有流程模板（下拉框）
  getAllLcmb() {
    const url = xtwhUrls.lcgl.getAllLcmb;
    const params = '';
    return this.http.post(url, params);
  }

  // 分页查询流程节点
  pagingQueryLcNode(lcmbId: string, page: number, rows: number) {
    const url = xtwhUrls.lcgl.pagingQueryLcNode;
    const params = publicMethods.generateFormData({ lcmbId, page, rows });
    return this.http.post(url, params);
  }

  // 根据流程节点查询节点审核人
  // queryJdshr(lcjdid: string, page: number, rows: 10) {
  //   const url = xtwhUrls.lcgl.queryJdshr;
  //   const params = publicMethods.generateFormData({ lcjdid, page, rows });
  //   return this.http.post(url, params);
  // }

  // 获取所有审核人列表
  // getAllShrList(page: number, rows: number, name?: string) {
  //   const url = xtwhUrls.lcgl.getAllShrList;
  //   const params = publicMethods.generateFormData({ page, rows, name });
  //   return this.http.post(url, params);
  // }

  // 新增流程节点审核人
  // addLcNodeShr(lcjdid: string, shrid: string) {
  //   const url = xtwhUrls.lcgl.addLcNodeShr;
  //   const params = publicMethods.generateFormData({ lcjdid, shrid });
  //   return this.http.post(url, params);
  // }

  // 删除当前节点下的审核人
  // deleteCurrentNodeShr(lcjdOpenid: string, shrOpenid: string) {
  //   const url = xtwhUrls.lcgl.deleteCurrentNodeShr;
  //   const params = publicMethods.generateFormData({ lcjdOpenid, shrOpenid });
  //   return this.http.post(url, params);
  // }

  // 分页查询流程模板业务关联
  pagingQueryYwGl(page: number, rows: number) {
    const url = xtwhUrls.lcgl.pagingQueryYwGl;
    const params = publicMethods.generateFormData({ page, rows });
    return this.http.post(url, params);
  }

  // 获取所有业务类型（select）
  getAllYwType(sjzd = 'lcywlxid') {
    const url = xtwhUrls.lcgl.getAllYwType;
    const params = publicMethods.generateFormData({ sjzd });
    return this.http.post(url, params);
  }

  // 获取所有流程模板（select）
  getAllLcTmp() {
    const url = xtwhUrls.lcgl.getAllLcmb;
    const params = '';
    return this.http.post(url, params);
  }

  // 分页查询字典数据
  pagingQueryZDdata(zdxsmc: string, page: number, rows: number) {
    const url = xtwhUrls.pagingZDdata;
    const params = publicMethods.generateFormData({ zdxsmc, page, rows });
    return this.http.post(url, params);
  }

  // 查询系统更新日志信息
  queryUpdateLog() {
    const url = xtwhUrls.queryUpdateLog;
    const params = '';
    return this.http.post(url, params);
  }

  /**
   * 保存或修改流程模板
   */
  saveOrEditLcTmp(name: string, code: number, ywlxid: string, description: string, lct: string, openid: string) {
    const URL = xtwhUrls.lcgl.saveOrEdit;
    const params = generateFormData({ name, code, ywlxid, description, lct, openid });
    return this.http.post(URL, params);
  }

  /**
   * 保存或修改流程节点
   */
  saveOrEditLcNode(norder: number, name: string, shrssz: string, lcmbid: string, openid: string) {
    const URL = xtwhUrls.lcgl.saveOrEditLcjd;
    const params = generateFormData({ norder, name, shrssz, lcmbid, openid });
    return this.http.post(URL, params);
  }

  /**
   * @param openid 要删除行的ID
   */
  delLcNode(openid: string) {
    const URL = xtwhUrls.lcgl.delJdShr;
    const par = generateFormData({ openid });
    return this.http.post(URL, par);
  }

  /**
   * @param lcjdid 流程节点ID
   */
  // queryNodePerson(lcjdid: string, page: number, rows: number) {
  //   const URL = xtwhUrls.lcgl.queryJdshr;
  //   const par = generateFormData({ lcjdid, page, rows });
  //   return this.http.post(URL, par);
  // }

  addOrEditTmpGl(lcywlxid: string, lcmbid: string, mbdqzt: number, openid: string) {
    const URL = xtwhUrls.lcgl.tmpYwGlSaveOrEdit;
    const par = generateFormData({ lcywlxid, lcmbid, mbdqzt, openid });
    return this.http.post(URL, par);
  }

  /**
   * @description: 新增修改系统字典
   * @return: void
   */
  addOrEditDic(
    field: string | number,
    field_name: string | number,
    value_field: string | number,
    display_field: string | number,
    sort: number,
    note: string | number,
    enable?: number,
    field_id?: string,
  ) {
    const URL = xtwhUrls.addOrEditZDInfo;
    const par = generateFormData({ field, field_name, value_field, display_field, sort, note, enable, field_id });
    return this.http.post(URL, par);
  }

  /**
   * @description: 系统字典启用状态
   * @return: void
   */
  changeDicEnable(openid: string, enable: number) {
    const URL = xtwhUrls.enableZDData;
    const par = generateFormData({ openid, enable });
    return this.http.post(URL, par);
  }
  /**
   * @description: 查询登录页配置信息
   */
  queryLoginPageInfo() {
    const URL = loginUrls.loginUrls.getSchoolInfo;
    return this.http.post(URL, '');
  }
  /**
   * @description: 上传图片
   */
  uploadImg(file: any) {
    const URL = xtwhUrls.files.uploadFile_icon;
    const params = generateFormData({ file });
    return this.http.post(URL, params);
  }
  // 修改登录页配置信息
  editLoginPageSetting(
    schoolname: string,
    topimg: string,
    logoimg: string,
    wemimg: string,
    version: string,
    copyright: string,
    links: string,
    background: string,
  ) {
    const URL = loginUrls.loginUrls.save;
    const params = generateFormData({
      schoolname,
      topimg,
      logoimg,
      wemimg,
      version,
      copyright,
      links,
      background,
    });
    return this.http.post(URL, params);
  }
  /**
   * @description: 查询主页页配置信息
   */
  queryHomePageInfo() {
    const URL = loginUrls.homePageUrls.getHomePageInfo;
    return this.http.post(URL, '');
  }
  // 修改主页面配置信息
  editHomePageInfo(defaulticon: string, logoimg: string, smalllogo: string, links: string) {
    const URL = loginUrls.homePageUrls.save;
    const params = generateFormData({ defaulticon, logoimg, smalllogo, links });
    return this.http.post(URL, params);
  }

  // 查询权限树
  queryPermissionsTree(name: string) {
    const url = xtwhUrls.qxwh.getAllTree;
    const params = generateFormData({ name });
    return this.http.post(url, params);
  }

  // 查询权限详情
  accessDetails(openid: string) {
    const url = xtwhUrls.qxwh.getById;
    const params = generateFormData({ openid });
    return this.http.post(url, params);
  }
}
